import React from 'react';
import { motion } from 'framer-motion';
export function PainPoints() {
  return <section className="py-24 px-4 bg-black" data-id="element-162">
      <div className="max-w-3xl mx-auto" data-id="element-163">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-164">
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6" data-id="element-165">
            ¿Te suena conocido esto?
          </h2>
          <p className="text-lg text-gray-300 leading-relaxed bg-dark-card p-6 rounded-2xl border border-dark-border" data-id="element-166">
            Domingo a las 11 de la noche. Mañana tenés práctica de taller de
            alimentos. Y todavía estás buscando cómo explicar la diferencia
            entre fermentación láctica y putrefacción, o cómo calcular el
            porcentaje exacto de sal para un embutido que sea seguro, sin que
            tus alumnos cometan errores graves de inocuidad o se queden
            completamente en blanco.
            <br data-id="element-167" />
            <br data-id="element-168" />
            <span className="text-gold-light font-medium" data-id="element-169">
              No es tu culpa.
            </span>{' '}
            Es que llevás años peleando con materiales genéricos, teoría sin
            contexto latinoamericano y recursos pensados para otros países que
            después tenés que reescribir entero para que tengan sentido en tu
            aula.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="space-y-6" data-id="element-170">
          <h3 className="text-xl font-bold text-white mb-8 text-center" data-id="element-171">
            El costo de no tener el material correcto:
          </h3>

          <ul className="space-y-4" data-id="element-172">
            {['Noches en vela buscando formulaciones técnicas correctas para conservas, embutidos o lácteos que puedas enseñar con confianza', 'Prácticas improvisadas porque no encontraste una receta técnica con los parámetros de pH, Brix y temperatura correctos a tiempo', 'Alumnos desconectados que sienten que la tecnología de alimentos no tiene nada que ver con su realidad ni con los productos de su región', 'Silencios incómodos cuando un alumno pregunta por qué el pH 4,6 es el límite de seguridad en conservas y no tenés una respuesta clara a mano', 'Fines de semana perdidos armando actividades prácticas, evaluaciones y proyectos productivos desde cero una y otra vez', 'Incertidumbre real sobre si los procesos que estás enseñando en el taller son técnicamente seguros para el consumo'].map((point, i) => <motion.li key={i} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="flex items-start gap-4 bg-dark-card p-4 rounded-xl border border-red-900/30" data-id="element-173">
                <span className="text-red-500 mt-1" data-id="element-174">🔴</span>
                <span className="text-gray-300" data-id="element-175">{point}</span>
              </motion.li>)}
          </ul>

          <div className="text-center mt-12 pt-8 border-t border-dark-border" data-id="element-176">
            <p className="text-2xl font-serif font-bold text-gold-gradient" data-id="element-177">
              Basta de regalar tu tiempo libre. Tu dedicación ya la tenés. Ahora
              te falta la herramienta.
            </p>
            <p className="text-xl mt-4 text-white" data-id="element-178">
              Planificá todo tu año hoy.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}